<div class="modal info-box fade" id="orderCancelReason" tabindex="-1" role="dialog" aria-labelledby="orderCancelReasonLabel">
    <div class="modal-dialog" role="document">
        <div class="modal-content p25">
            <div class="modal-body">
                <div class="row mb50">
                    <div class="col-md-12">
                        <button 
                            type="button" 
                            class="hod-button mr10" 
                            ng-class="{'btn' : cancelReason.value == item.value }"
                            ng-click="setCancelReason(item.value)" 
                            ng-repeat="item in orderCancelReasons">
                            {{ item.name }}
                        </button>
                    </div>
                    <div class="col-md-9 mt30" ng-if="cancelReason.value === 'OTHER'">
                        <div class="form-group floating">
                            <input type="text" ng-model="cancelReason.reason" class="form-control input-md" placeholder="Reason">
                            <label>Reason</label>
                        </div>
                    </div>
                </div>

                <div class="">
                    <button type="submit" class="btn pull-right btn-danger" ng-click="cancelOrder()">
                        Submit
                    </button>
                    <button type="button" class="btn pull-left btn-default" data-dismiss="modal">Cancel
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>